"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JoinPrimary = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var JoinPrimary = exports.JoinPrimary = function JoinPrimary(props) {
  var title = props.title,
    isHighlighted = props.isHighlighted,
    theme = props.theme,
    onClick = props.onClick,
    style = props.style;
  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: onClick,
    className: "h-10 w-full rounded-3xl items-center justify-center self-center px-4 text-lg font-medium hover:text-white ".concat(isHighlighted ? "bg-boost-primary-500 hover:bg-boost-primary-400 text-white" : theme === "dark" ? "border border-boost-primary-500 hover:bg-boost-primary-500 text-white" : "border-2 border-boost-primary-400 bg-boost-primary-400 hover:bg-boost-primary-500 text-white hover:text-black"),
    style: style
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold"
  }, title));
};